import { routes } from '../routerHelper';

export enum ANALYTIKA_SCREENS {
  PROFILE = 'profile_screen',
  AMOUNT = 'add_amount_screen',
  CREDIT_ADDED = 'credit_added_screen',
  INSUFFICIENT_WALLET_BALANCE_ERROR = 'insufficient_wallet_balance_page',
  NO_SECONDARY_METHOD_SELECTED_ERROR = 'no_secondary_method_selected',
  TECHNICAL_ERROR = 'technical_error_page',
  SEARCH = 'search_screen',
  MARKETPLACE_REQUEST_DELIVERY = 'marketplace_request_delivery',
  MARKETPLACE_ACTIVE_DELIVERIES = 'marketplace_active_deliveries',
  MARKETPLACE_ACTIVE_DELIVERY_DETAILS = 'marketplace_active_delivery_details',
  MARKETPLACE_COMPLETED_DELIVERIES = 'marketplace_completed_deliveries',
  MARKETPLACE_COMPLETED_DELIVERY_DETAILS = 'marketplace_completed_delivery_details',
  MARKETPLACE_DASHBOARD = 'marketplace_dashboard',
  ADD_NEW_ADDRESS = 'add_new_address_screen',
  PAYMENTS = 'payments_screen',
  ADDRESSES = 'addresses_screen',
  SEGMENTATION_START = 'welcome',
  SEGMENTATION_EXISTING_DETAILS = 'existing_customer',
  SEGMENTATION_NEW_MERCHANT_DETAILS = 'new_customer',
  NO_SCREEN = 'no_screen'
}

export const ANALYTIKA_ROUTES_TO_SCREENS = {
  '/deliveries/active': ANALYTIKA_SCREENS.MARKETPLACE_ACTIVE_DELIVERIES,
  '/deliveries/past': ANALYTIKA_SCREENS.MARKETPLACE_COMPLETED_DELIVERIES,
  '/deliveries/dashboard': ANALYTIKA_SCREENS.MARKETPLACE_DASHBOARD,
  '/deliveries': ANALYTIKA_SCREENS.MARKETPLACE_REQUEST_DELIVERY,
  '/search': ANALYTIKA_SCREENS.SEARCH,
  '/profile': ANALYTIKA_SCREENS.PROFILE,
  '/payments': ANALYTIKA_SCREENS.PAYMENTS,
  '/addresses': ANALYTIKA_SCREENS.ADDRESSES,
  [routes.segmentationStart]: ANALYTIKA_SCREENS.SEGMENTATION_START,
  [routes.existingMerchantDetails]: ANALYTIKA_SCREENS.SEGMENTATION_EXISTING_DETAILS,
  [routes.newMerchantDetails]: ANALYTIKA_SCREENS.SEGMENTATION_NEW_MERCHANT_DETAILS
};

export enum CANCELLATION_REASONS {
  HIGH_ETA = 'highEta',
  CAPTAIN_LATE = 'captainLate',
  DUPLICATE_BOOKING = 'duplicateBooking',
  ANOTHER_CAPTAIN = 'anotherCaptain',
  BIG_ORDER_SIZE = 'bigOrderSize',
  CAPTAIN_REFUSED = 'captainRefused',
  OTHERS = 'others'
}

export enum ANALYTIKA_ACTIONS {
  PAGE_OPEN = 'PAGE_OPEN',
  REQUEST_SUBMITTED = 'REQUEST_SUBMITTED'
}

export enum ANALYTIKA_API_NAMES {
  MERCHANT_CONFIG = 'MERCHANT_CONFIG'
}

export enum ANALYTIKA_EVENTS_V2 {
  EXPR_CLICK_RAISEESCALATION = 'expr_click_raiseescalation',
  EXPR_ACKNOWLEDGE_HTTP_REQ_FAIL = 'expr_acknowledge_http_req_fail',
  EXPR_ACKNOWLEDGE_MISS_CUST_PHONE = 'expr_acknowledge_miss_cust_phone',
  EXPR_ACKNOWLEDGE_MISS_USER_PHONE = 'expr_acknowledge_miss_user_phone',
  EXPR_ACKNOWLEDGE_NEARBY_LOC_ERR = 'expr_acknowledge_nearby_loc_err',
  EXPR_ACKNOWLEDGE_PAGE_OPEN_ERROR = 'expr_acknowledge_page_open_error',
  EXPR_ACKNOWLEDGE_CREDIT_ADDED = 'expr_acknowledge_credit_added',
  EXPR_ACKNOWLEDGE_PAYMENT_MESSAGE = 'expr_acknowledge_payment_message',
  EXPR_ACKNOWLEDGE_PRIMARY_MISSING = 'expr_acknowledge_primary_missing',
  EXPR_ACKNOWLEDGE_SECOND_MISSING = 'expr_acknowledge_second_missing',
  EXPR_ACKNOWLEDGE_SAME_PICK_DROP = 'expr_acknowledge_same_pick_drop',
  EXPR_ALERT_CHARGE_TO_CARD = 'expr_alert_charge_to_card',
  EXPR_ALERT_NEG_BALANCE = 'expr_alert_neg_balance',
  EXPR_ALERT_ZERO_BALANCE = 'expr_alert_zero_balance',
  EXPR_BACK_CREDIT_ADDED = 'expr_back_credit_added',
  EXPR_CANCEL_WALLET = 'expr_cancel_wallet',
  EXPR_CLICK_CALL_CARE = 'expr_click_call_care',
  EXPR_CLICK_CNF_CREATEAGAIN = 'expr_click_cnf_createagain',
  EXPR_CLICK_DEL_PAGINATION = 'expr_click_del_pagination',
  EXPR_CLICK_DOWNLOADRECORDS = 'expr_click_downloadrecords',
  EXPR_CLICK_LOGOUT = 'expr_click_logout',
  EXPR_CLICK_SEARCH = 'expr_click_search',
  EXPR_INVALID_CONTACT_PHONE = 'expr_invalid_contact_phone',
  EXPR_INVALID_CUST_PHONE = 'expr_invalid_cust_phone',
  EXPR_NEXT_ADD_CREDIT = 'expr_next_add_credit',
  EXPR_RECHARGE_WALLET = 'expr_recharge_wallet',
  EXPR_REDIRECT_ACC_DISABLED = 'expr_redirect_acc_disabled',
  EXPR_REDIRECT_NO_PORTALACCESS = 'expr_redirect_no_portalaccess',
  EXPR_TAP_SEARCH = 'expr_tap_search',
  EXPR_TOPUP_CHARGE_TO_CARD = 'expr_topup_charge_to_card',
  EXPR_TOPUP_NEG_BALANCE = 'expr_topup_neg_balance',
  EXPR_TOPUP_WALLET = 'expr_topup_wallet',
  EXPR_TOPUP_ZERO_BALANCE = 'expr_topup_zero_balance',
  EXPR_UPDATE_DROPOFF = 'expr_update_dropoff',
  EXPR_UPDATE_PICKUP = 'expr_update_pickup',
  EXPR_VIEW_SCREEN = 'expr_view_screen',
  EXPR_CLICK_DEL_REQ_FORM = 'expr_click_del_req_form',
  EXPR_FAIL_DEL_REQ_FORM = 'expr_fail_del_req_form',
  EXPR_SUBMIT_DEL_REQ_FORM = 'expr_submit_del_req_form',
  EXPR_BACK_CUSTOM_DROPOFF = 'expr_back_custom_dropoff',
  EXPR_CANCEL_CUSTOM_DROPOFF = 'expr_cancel_custom_dropoff',
  EXPR_CONFIRM_CUSTOM_DROPOFF = 'expr_confirm_custom_dropoff',
  EXPR_SUBMIT_CUSTOM_DROPOFF = 'expr_submit_custom_dropoff',
  EXPR_DRAG_DROPOFF_PIN = 'expr_drag_dropoff_pin',
  EXPR_SAVE_PAYMENT_SETTING = 'expr_save_payment_setting',
  EXPR_SU_CLICK_CONTINUE = 'expr_su_click_continue',
  EXPR_SU_CLICK_BUTTON = 'expr_su_click_button'
}
